<template lang="pug">
  vm-prompt(vm-size="large" @vm-cancel="close" @vm-accept="savePayment" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalInvoicePaymentsVisible" :vm-title="$t('payments.add')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-align="center", vm-w=4)
        h3 {{ $t('strings.invoice') }}: {{ invoice.number }}
      vm-col(vm-align="center", vm-w=4)
        h3 {{ $t('strings.total_payment') }}: {{ invoice.total | currency }}
      vm-col(vm-align="center", vm-w=4)
        h3 {{ $t('strings.total_remaining') }}: {{ invoice.total_payments_amount | currency }}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group
          vm-currency(autofocus v-model="form.total" :label='$t("payments.total")' :placeholder='$t("payments.total_placeholder")' :danger="$v.form.total.$invalid && $v.form.total.$model" :danger-text="!$v.form.total.maxValue ? $t('validation.max.total', { attribute: $t('payments.total'), max: $t('strings.total_payment') }) : $t('validation.required', { attribute: $t('payments.total') })")
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group.margin-left
          vm-date-picker.full-width(type="date" :label="$t('payments.date')" :placeholder="$t('strings.select_date')" :danger="$v.form.date.$invalid && $v.form.date.$model" :danger-text="$t('validation.required', { attribute: $t('invoices.date') })" v-model="form.date" )
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group.margin-left
          vm-select(:placeholder='$t("payments.type_placeholder")' :danger="$v.form.type.$invalid && $v.form.type.$model" :danger-text="$t('validation.required', { attribute: $t('payments.type') })" v-model="form.type" :label='$t("payments.type")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in types")
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group.margin-left
          vm-input(:placeholder='$t("payments.receipt_placeholder")' :danger="$v.form.receipt.$invalid && $v.form.receipt.$model" :danger-text="$t('validation.required', { attribute: $t('payments.receipt') })" v-model="form.receipt" :label='$t("payments.receipt")')
      vm-col(vm-justify="center", vm-align="center", vm-w=2)
        b-form-group.margin-left
          vm-select(:placeholder='$t("payments.type_placeholder")' :danger="$v.form.bank.$invalid && $v.form.bank.$model" :danger-text="$t('validation.required', { attribute: $t('payments.bank') })" v-model="form.bank" :label='$t("payments.bank")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in banks")
    vm-row
      vm-table.full-width(max-height="350px" max-items="3" pagination :data="payments" )
        template(slot="thead")
          vm-th(:key="index" v-for="(column, index) in columns") {{ $t('payments.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
              slot(v-if="column == 'total' || column == 'subtotal'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'created_at' || column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column == 'type'") {{ $t('payments.'+ data[indextr]['type']) }}
              slot(v-if="column == 'bank'") {{ $t('payments.'+ data[indextr]['bank']) }}
              slot(v-if="column != 'type' && column != 'created_at' && column != 'name' && column != 'bank' && column != 'date' && column != 'total' && column != 'subtotal'") {{data[indextr][column]}}
            vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="deletePaymentConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, maxValue } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import { VmCurrency } from 'vm-currency'
const { mapGetters, mapActions } = createNamespacedHelpers('Invoices')

export default {
  name: 'ModalInvoicePayments',
  components: {
    VmCurrency
  },
  mixins: [ModalMixin1],
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    amount: null,
    columns: [
      'subtotal',
      'total',
      'tax_amount',
      'date',
      'type',
      'receipt',
      'bank',
      'user_display',
      'created_at'
    ],
    types: [
      {
        id: 'transfer',
        name: 'Transferencia'
      },
      {
        id: 'check',
        name: 'Cheque'
      },
      {
        id: 'cash',
        name: 'Efectivo'
      },
      {
        id: 'other',
        name: 'Otro'
      }
    ],
    banks: [
      {
        id: 1,
        name: 'Banorte'
      },
      {
        id: 2,
        name: 'Banregio'
      },
      {
        id: 3,
        name: 'Intercam'
      },
      {
        id: 4,
        name: 'Monex'
      }
    ]
  }),
  validations () {
    return {
      form: {
        total: {
          required,
          maxValue: maxValue(this.invoice.total_payments_amount)
        },
        date: {
          required
        },
        type: {
          required
        },
        receipt: {
          required
        },
        bank: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalInvoicePaymentsVisible', 'catalog', 'payments'])
  },
  watch: {
    'form.total' (total) {
      this.form.tax_amount = (total * this.invoice.purchase_order.tax_type) / 100
      this.form.subtotal = parseFloat(total) - +parseFloat(this.form.tax_amount)
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'addPayment',
      'setModalInvoicePaymentsVisible',
      'loadPayments',
      'refreshInvoice',
      'deletePayment'
    ]),
    savePayment () {
      this.data = {
        ...this.form,
        invoice_id: this.invoice.id
      }
      this.addPayment(this.data).then(() => {
        this.refreshInvoice({ id: this.invoice.id }).then((response) => {
          this.invoice = response
        })
        this.loadPayments({ page: 1, id: this.invoice.id })
        this.form = { total: 0 }
      })
    },
    handleChange (date) {
      this.form.date = date
    },
    close () {
      this.$emit('reload')
      this.setModalInvoicePaymentsVisible(false)
    },
    async deletePaymentConfirm (record) {
      let t = this
      this.auxDeleteRecord = () => {
        t.deletePayment(record).then(() => {
          t.selected = []
          this.loadPayments({ page: 1, id: this.invoice.id })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.payment'),
          attribute: record.id
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>
<style scoped>
  .margin-left {
    margin-left: 10px;
  }
</style>
